import { gql } from '@apollo/client';
const UPDATE_SPECIFICATION_TEAM_MEMBERS = gql `
  mutation UpdateSpecificationTeamMembersNode(
    $teamMembersId: ID!
    $adminName: String
    $patternerName: String
    $designerName: String
    $productionName: String
  ) {
    updateSpecificationTeamMembersNode(
      teamMembersId: $teamMembersId
      adminName: $adminName
      patternerName: $patternerName
      designerName: $designerName
      productionName: $productionName
    ) {
      specificationTeamMembersNode {
        id
        adminName
        patternerName
        designerName
        productionName
      }
    }
  }
`;
export default UPDATE_SPECIFICATION_TEAM_MEMBERS;
